const DAY_MS = 24 * 60 * 60 * 1000;

// subDays keeps the browser's wall-clock time, which shifts a UTC midnight by an hour across DST.
const subUtcDays = (date: Date, days: number) =>
  new Date(date.getTime() - days * DAY_MS);

export default subUtcDays;
